export const SQS_PROVIDER_NAME = 'EcdReclassificationStateMachine'
